
const referral = {
  "Referral Program": [
    {
      question: "Is there any referral program and will I get rewarded for referring someone?",
      answer: "Yes, we do have a referral program. Please visit the Refer tab to know more about the program."
    }
  ]
}

export default referral;